import React from 'react';

const NAV_ITEMS = [
  { page: 'clicker', icon: '/assets/nav-clicker-v2.png', label: 'Кликер' },
  { page: 'shop', icon: '/assets/nav-shop-v2.png', label: 'Магазин' },
  { page: 'cards', icon: '/assets/nav-friends-v2.png', label: 'Друзья' },
  { page: 'quests', icon: '/assets/nav-quests-v2.png', label: 'Квесты' },
  { page: 'profile', icon: '/assets/nav-profile-v2.png', label: 'Профиль' },
];

export default function AppShell({
  avatarUrl, username, clanTag, rank, rankProgress, clickCount, maxClicks,
  formatNumber, incomePerDay, effectsEnabled, onToggleEffects, onNavigate,
  isVideoLoaded, toastMessage, showToast, children,
}) {
  const visibleUsername = username.length > 7 ? `${username.slice(0, 7)}...` : username;
  const rankGoal = maxClicks[rank];

  return (
    <div className="App">
      <header>
        <div className="header_row" style={{ gap: 0 }}>
          <div className="header_av">
            <img src={avatarUrl} alt="Аватар пользователя" className="header_firts_row_auth_img" />
            <div className="right-side">
              <div className="Nick">{visibleUsername} {clanTag ? `[${clanTag}]` : null}</div>
              <div className="online-status"><div className="online-circle" /> Онлайн</div>
            </div>
          </div>
          <div className="top">
            <button className="left app-icon-button" onClick={() => onNavigate('refbord')} aria-label="Реферальный рейтинг"><img src="/assets/currency-diamond-v2.png" alt="" /></button>
            <button className="right app-icon-button" onClick={() => onNavigate('leaderboard')} aria-label="Общий рейтинг"><img src="/assets/rank-trophy-v2.png" alt="" /></button>
          </div>
        </div>
        <div className="header_row">
          <div className="Main_Header_Rank_Pole">
            {rank}
            <div className="Ranks_slider_container">
              <div className="Ranks_slider" style={{ width: `${rankProgress}%`, backgroundColor: '#00fe57' }} />
              <div className="Ranks_slider_text">{rankGoal !== undefined ? `${formatNumber(clickCount)}/${formatNumber(rankGoal)}` : 'Загрузка...'}</div>
            </div>
          </div>
          <div className="Main_Setting">
            <button className="Left_sett app-icon-button" onClick={() => onNavigate('soon')} aria-label="Robux"><img src="/assets/imgur/xlhFB2w.png" alt="" /></button>
            <div className="Main_sett">Доход в 24 часа: {incomePerDay}</div>
            <button className={`Right_sett app-icon-button ${!effectsEnabled ? 'button-disabled' : ''}`} onClick={onToggleEffects} aria-label="Переключить эффекты"><img src="/assets/imgur/HGizS9F.png" alt="" /></button>
          </div>
        </div>
      </header>

      <div className="Main">
        {isVideoLoaded && <video autoPlay loop muted playsInline disablePictureInPicture controlsList="nodownload" className="background-gif"><source src="/кто.mp4" type="video/mp4" /></video>}
        <img id="fallback-image" src="/assets/imgur/EogKJ6D.jpg" alt="Резервный фон" className="background-gif" style={{ zIndex: -2 }} />
        {children}
        <div className="income-animation" id="income-animation"><div className="income-text" id="income-text" /></div>
        {toastMessage && <div className={`toast-notification ${showToast ? 'show' : 'hide'}`}>{toastMessage}</div>}
      </div>

      <footer>
        {NAV_ITEMS.map((item) => (
          <button className="footer_btn_div app-nav-button" onClick={() => onNavigate(item.page)} key={item.page}>
            <span className="footer_btn_div_inline"><img src={item.icon} alt="" /><span className="footer_text">{item.label}</span></span>
          </button>
        ))}
      </footer>
    </div>
  );
}
